"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("..");

var _Button = _interopRequireDefault(require("../Button"));

var __jsx = _react["default"].createElement;
var defaults = {
  background: {
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  body: function body(_ref) {
    var children = _ref.children,
        isLoading = _ref.isLoading;
    return {
      boxSizing: "border-box",
      position: "relative",
      pointerEvents: "none",
      height: "100%",
      minHeight: "inherit",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      visibility: isLoading ? "hidden" : "visible",
      overflow: "hidden",
      textAlign: "center",
      // lineHeight: "1 !important",
      // whiteSpace: "nowrap",
      // textOverflow: "ellipsis", display: block must be on to make this work!!!
      __children: children
    };
  },
  loader: {
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    __children: "LOAD"
  }
};

var _default = function _default(props) {
  var _sx = props.sx,
      children = props.children,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "children"]);
  return (0, _.jsx)(_Button["default"], (0, _extends2["default"])({
    sx: function sx(state) {
      var _splitSx = (0, _.splitSx)(typeof _sx === "function" ? _sx(state) : _sx),
          _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
          css = _splitSx2[0],
          customSx = _splitSx2[1];

      return {
        $css: css
      };
    }
  }, restProps), function (state) {
    var newState = (0, _objectSpread2["default"])({}, state, {
      children: typeof children === "function" ? children(state) : children
    });

    var _splitSx3 = (0, _.splitSx)(typeof _sx === "function" ? _sx(newState) : _sx),
        _splitSx4 = (0, _slicedToArray2["default"])(_splitSx3, 2),
        css = _splitSx4[0],
        customSx = _splitSx4[1];

    var loaderSpec = (0, _.getElementSpec)(customSx.$loader, defaults.loader, newState);
    var backgroundSpec = (0, _.getElementSpec)(customSx.$background, defaults.background, newState);
    var bodySpec = (0, _.getElementSpec)(customSx.$body, defaults.body, newState);
    return (0, _.jsx)(_react["default"].Fragment, null, (0, _.createElement)(backgroundSpec), (0, _.createElement)(bodySpec), newState.isLoading && (0, _.createElement)(loaderSpec));
  });
};

exports["default"] = _default;